import { BasicStoreFragment } from 'drycut-graphql';
import { useEffect, useState } from 'react';
import { useInterval } from 'usehooks-ts';

type Props = {
  store: BasicStoreFragment;
};

export function useStoreWaitingTimeCountDown({ store }: Props): number {
  const initial = store.waitingTime || 0;

  const [time, setTime] = useState<number>(initial);
  const [shouldStop, setShouldStop] = useState<boolean>(false);

  useInterval(
    () => {
      if (time <= 0) {
        setShouldStop(true);
      } else {
        setTime((prevTime) => prevTime - 1);
      }
    },
    shouldStop ? null : 1000,
  );

  // If we get an update from the server, we stop the interval and update the time. This will happen
  // only when the component is under a RealTimeStoreProvider.
  useEffect(() => {
    const updatedTime = store.waitingTime;

    // If it's a number (be careful, it can be 0), we update the time and restart the interval.
    if (typeof updatedTime === 'number') {
      setTime(updatedTime);
      setShouldStop(false);
    }
  }, [store]);

  return time;
}
